import { CANAL, APP_VERSION } from "../helpers/constants";
import { axiosInstance } from "../helpers/axios";

const userAgent = window.navigator.userAgent;

const getSolicitudes = (
  usuario,
  distribuidor,
  sucursal,
  vendedor,
  securitykey,
) => {
  return axiosInstance
    .post("getSolicitudes/", {
      userAgent: userAgent,
      carrierCelular: userAgent,
      usuario: usuario,
      canal: CANAL,
      version: APP_VERSION,
      distribuidor: distribuidor,
      sucursal: sucursal,
      vendedor: vendedor,
      llaveSeguridad: securitykey,
    })
    .then((res) => {
      const data = res.data;
      return data;
    })
    .catch((err) => {
      console.log("error");
      console.log(err.message);
      return Promise.reject(err);
    });
};

const getHistorialEstatus = (usuario, securitykey, idSolicitud) => {
  return axiosInstance
    .post("getHistorialEstatus/", {
      canal: CANAL,
      version: APP_VERSION,
      carrierCelular: userAgent,
      userAgent: userAgent,
      idSolicitud: idSolicitud,
      ip_dispositivo: "0.0.0.0",
      latitud: "19.414179",
      longitud: "-100.391864",
      usuario: usuario,
      llaveSeguridad: securitykey,
    })
    .then((res) => {
      const data = res.data;
      return data;
    })
    .catch((err) => {
      console.log("error");
      console.log(err.message);
      return Promise.reject(err);
    });
};

const getHistorialEstatusFondeo = (usuario, securitykey, idSolicitud) => {
  return axiosInstance
    .post("getHistorialFondeo/", {
      canal: CANAL,
      version: APP_VERSION,
      carrierCelular: userAgent,
      userAgent: userAgent,
      idSolicitud: idSolicitud,
      ip_dispositivo: "0.0.0.0",
      latitud: "19.414179",
      longitud: "-100.391864",
      usuario: usuario,
      llaveSeguridad: securitykey,
    })
    .then((res) => {
      const data = res.data;
      return data;
    })
    .catch((err) => {
      console.log("error");
      console.log(err.message);
      return Promise.reject(err);
    });
};

const getSolicitudesSearch = (
  usuario,
  distribuidor,
  sucursal,
  vendedor,
  securitykey,
  textoBuscar,
) => {
  return axiosInstance
    .post("getSolicitudesFind/", {
      userAgent: userAgent,
      carrierCelular: userAgent,
      usuario: usuario,
      canal: CANAL,
      version: APP_VERSION,
      distribuidor: distribuidor,
      sucursal: sucursal,
      vendedor: vendedor,
      llaveSeguridad: securitykey,
      find: textoBuscar,
      ip_dispositivo: "0.0.0.0",
      latitud: "19.414179",
      longitud: "-100.391864",
    })
    .then((res) => {
      const data = res.data;
      return data;
    })
    .catch((err) => {
      console.log("error");
      console.log(err.message);
      return Promise.reject(err);
    });
};

export default {
  getSolicitudes,
  getHistorialEstatus,
  getHistorialEstatusFondeo,
  getSolicitudesSearch,
};
